import React from "react";

export const Tick = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6514 22.8105C10.5292 22.8106 10.4082 22.7865 10.2953 22.7398C10.1824 22.693 10.0798 22.6245 9.99333 22.5381L5.31165 17.856C5.15053 17.6791 5.06376 17.4469 5.06935 17.2077C5.07493 16.9684 5.17246 16.7406 5.34166 16.5714C5.51086 16.4022 5.73874 16.3046 5.97796 16.2991C6.21718 16.2935 6.44936 16.3802 6.62628 16.5414L10.6498 20.5649L23.3687 7.84608C23.5456 7.68496 23.7778 7.59818 24.017 7.60377C24.2562 7.60936 24.4841 7.70688 24.6533 7.87608C24.8225 8.04528 24.92 8.27316 24.9256 8.51238C24.9312 8.75161 24.8444 8.98379 24.6833 9.16071L11.3096 22.5377C11.2231 22.6241 11.1205 22.6926 11.0076 22.7394C10.8947 22.7861 10.7737 22.8102 10.6514 22.8101"
      fill="#28BE63"
    />
  </svg>
);
